import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr } from 'src/app/shared/utils';
import { IndicadorInfo, DashboardIndicadores } from '../../dashboard.model';
import { DashboardIndicadoresSemanaisService } from './dashboard-indicadores-semanais.service';

@Component({
    selector: 'app-dashboard-indicadores-semanais',
    templateUrl: './dashboard-indicadores-semanais.component.html',
    styleUrls: ['./dashboard-indicadores-semanais.component.css'],
    standalone: false
})
export class DashboardIndicadoresSemanaisComponent implements OnInit {
    loading = false;
    indicadoresSemanais: IndicadorInfo[] = [];
    today = new Date();
    weekStart: Date;
    weekEnd: Date;

    constructor(
        private service: DashboardIndicadoresSemanaisService,
        private snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
        this.computeWeekRange();
        this.fetchIndicadores();
    }

    private computeWeekRange(): void {
        const day = this.today.getDay(); // 0=Sunday ... 6=Saturday
        const start = new Date(this.today);
        start.setDate(this.today.getDate() - day);
        const end = new Date(this.today);
        end.setDate(this.today.getDate() + (6 - day));

        this.weekStart = start;
        this.weekEnd = end;
    }

    private fetchIndicadores(): void {
        this.loading = true;
        this.service.getIndicadoresSemanais().subscribe({
            next: (semanais: DashboardIndicadores) => {
                this.indicadoresSemanais = [
                    {
                        titulo: 'Criados',
                        valor: semanais.criados,
                        icone: 'add_circle',
                        cor: 'primary',
                        descricao: 'Quantidade total de DIOs criados na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                    {
                        titulo: 'Executados',
                        valor: semanais.executados,
                        icone: 'check_circle',
                        cor: 'success',
                        descricao: 'Quantidade de DIOs executados pelos condutores na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                    {
                        titulo: 'Aguardando Execução',
                        valor: semanais.naoExecutados,
                        icone: 'cancel',
                        cor: 'warn',
                        descricao: 'Quantidade de DIOs ainda não executados pelos condutores na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                    {
                        titulo: 'Executor',
                        valor: semanais.executor,
                        icone: 'pending_actions',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de atesto do Funcionário na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                    {
                        titulo: 'Aferição',
                        valor: semanais.afericao,
                        icone: 'assessment',
                        cor: 'primary',
                        descricao: 'Quantidade de DIOs pendentes de aferição na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                    {
                        titulo: 'Fiscal',
                        valor: semanais.fiscal,
                        icone: 'gavel',
                        cor: 'accent',
                        descricao: 'Quantidade de DIOs pendentes de validação do Fiscal na semana vigente (do domingo ao sábado)',
                        periodicidade: 'Semanal'
                    },
                ];
            },
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    getCorClasse(cor: string): string {
        const cores: { [key: string]: string } = {
            'primary': 'text-primary',
            'success': 'text-success',
            'warn': 'text-danger',
            'accent': 'text-warning'
        };
        return cores[cor] || 'text-primary';
    }
}
